// extracted by mini-css-extract-plugin
export default {"root":"_2-xwP","content":"VS1I3"};